import { render, staticRenderFns } from "./BarrelPaymentRecord.vue?vue&type=template&id=2f59d3bf&scoped=true&"
import script from "./BarrelPaymentRecord.vue?vue&type=script&lang=js&"
export * from "./BarrelPaymentRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f59d3bf",
  null
  
)

export default component.exports